// components/EditProfileModal.jsx
import React from "react";

const EditProfileModal = ({ isOpen, onClose }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center z-50">
      <div className="bg-white p-6 rounded-lg shadow-lg w-full max-w-md">
        <h2 className="text-lg font-semibold mb-4">Edit Profile</h2>
        <form>
          <label className="block mb-2 text-sm font-medium">Bio:</label>
          <textarea className="w-full border rounded p-2 mb-4" rows="3" placeholder="Update your bio" />

          <label className="block mb-2 text-sm font-medium">Profile Picture URL:</label>
          <input type="text" className="w-full border rounded p-2 mb-4" placeholder="Image URL" />

          <div className="flex justify-end space-x-2">
            <button type="button" onClick={onClose} className="px-4 py-2 text-sm bg-gray-200 rounded hover:bg-gray-300">
              Cancel
            </button>
            <button type="submit" className="px-4 py-2 text-sm bg-blue-600 text-white rounded hover:bg-blue-700">
              Save
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default EditProfileModal;
